
export enum RelationType {
  Parents = 'parents',
  Children = 'children',
  Related = 'related',
  Clean = 'archive',
  ChangeNotification = 'changeNotification', // one way relation where the items of this relation type should be notified
}

export type RelationsEntity = { [k in RelationType]?: string[] };

